module.exports = __webpack_public_path__ + "img/hands.f1f85720.png";